import React from 'react';
import './OperationalDashboards.css';
import { FaUserCheck, FaChartLine, FaRegMoneyBillAlt, FaGavel, FaCheckCircle ,FaBook } from 'react-icons/fa';

function OperationalDashboards() {
    const dashboards = [
        {
            title: "KYC Management",
            icon: <FaUserCheck />,
            tagline: "Centralized Status Tracker",
            features: [
                "AI-assisted document verification",
                "AI-powered face detection",
                "Duplicate & risk profile alerts",
                "Regulatory compliance indicators"
            ],
            color: "blue"
        },
        {
            title: "Recovery & Collection",
            icon: <FaChartLine />,
            tagline: "Precision Tracking",
            features: [
                "Day-wise & overdue tracking",
                "Field collection updates",
                "NPA Bucket Management",
                "Legal/arbitration case tagging"
            ],
            color: "red"
        },
        {
            title: "Payment Control",
            icon: <FaRegMoneyBillAlt />,
            tagline: "Automated Flow",
            features: [
                "Bulk interest & maturity payouts",
                "Auto-posting to ledgers",
                "Success/failure monitoring",
                "Clone or excel upload last month expenses"
            ],
            color: "green"
        },
        {
            title: "Auction Monitoring",
            icon: <FaGavel />,
            tagline: "Asset Integrity",
            features: [
                "Periodic auction alerts",
                "Ornament transit tracking",
                "Appraisal status monitoring",
                "HO only managable auction module"
            ],
            color: "purple"
        },
        {
            title: "Management Summary",
            icon: <FaBook />,
            tagline: "Summery panel",
            features: [
                "Organization-wide financial snapshot",
                "Branch and staff performance analytics",
                "NPA bucket automation with recovery efficiency ratios",
                "Compliance and audit readiness scoring"
            ],
            color: "red"
        }
    ];

    return (
        <section className="dashboards-section-premium">
            <div className="dashboards-container-premium">
                <div className="dash-header-premium">
                    <span className="dash-tag-premium">Operation Excellence</span>
                    <h2 className="dash-title-premium">Institutional Control Centers</h2>
                    <p className="dash-subtitle-premium">Specialized, role-based dashboards for every department in your financial ecosystem.</p>
                </div>

                <div className="dash-grid-premium">
                    {dashboards.map((dash, idx) => (
                        <div key={idx} className={`dash-card-premium ${dash.color}`}>
                            <div className="dash-card-top-premium">
                                <div className="dash-icon-premium">{dash.icon}</div>
                                <div className="dash-titles-premium">
                                    <h3>{dash.title}</h3>
                                    <span className="dash-tagline-premium">{dash.tagline}</span>
                                </div>
                            </div>
                            <div className="dash-divider-premium"></div>
                            <ul className="dash-list-premium">
                                {dash.features.map((f, i) => (
                                    <li key={i}>
                                        <FaCheckCircle className="dash-check-premium" />
                                        {f}
                                    </li>
                                ))}
                            </ul>
                            {/* <div className="dash-card-footer-premium"> */}
                                {/* <span>Learn More</span> */}
                                {/* <div className="dash-arrow-premium">→</div> */}
                            {/* </div> */}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default OperationalDashboards;
